import type { ReactNode } from "react";

export function RecordTable({ head, children, label }: { head: string[]; children: ReactNode; label: string }) {
  return (
    <div className="overflow-x-auto px-4 pb-4 max-compact:px-2">
      <table aria-label={label} className="w-full border-separate border-spacing-0 text-ui">
        <thead>
          <tr>
            {head.map((h) => (
              <th
                key={h}
                scope="col"
                className="border-b border-divider px-2.5 py-1.5 text-left text-md font-strong whitespace-nowrap text-muted"
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="[&_td]:border-b [&_td]:border-divider [&_td]:px-2.5 [&_td]:py-2 [&_td]:align-top">
          {children}
        </tbody>
      </table>
    </div>
  );
}
